import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import '@babel/polyfill'

import VeeValidate from "./plugins/VeeValidate"
import Convert from "./plugins/Convert"
import VueQuillEditor from "./plugins/VueQuillEditor"
import VueGoogleMaps from "./plugins/VueGoogleMaps"
import VueApexCharts from "./plugins/VueApexCharts"
import VueAwesomeSwiper from "./plugins/VueAwesomeSwiper"
import VueSocialSharing from "./plugins/VueSocialSharing"
import VueZoomer from "./plugins/VueZoomer"
import Firebase from "./plugins/Firebase"
import VCurrencyField from "./plugins/VCurrencyField"
import VueHtml2Canvas from "./plugins/VueHtml2Canvas"
import VueAdvancedCropper from "./plugins/VueAdvancedCropper"

import GmapVue from "./plugins/GmapVue"

import '@/assets/css/main.css'

import { TokenService } from "@/service/Storage.Service.js"
import { getCdnDisplayUrl, getCdnLegacyDisplayUrl } from "@/utils/cdn"

// Template Vue 2 hanya bisa memanggil method instance, bukan hasil import.
// Daftarkan global supaya :src="getCdnDisplayUrl(...)" di semua halaman jalan.
Vue.mixin({
  methods: {
    getCdnDisplayUrl,
    getCdnLegacyDisplayUrl
  }
})

if (TokenService.getToken()) {
  store.commit("setToken", TokenService.getToken())
  store.commit("setUser", JSON.parse(TokenService.getUser()))
  store.commit("setMenu", JSON.parse(TokenService.getMenu()))
  
  store.commit("setReload", TokenService.getReload())

  store.commit("setCounter", JSON.parse(TokenService.getCounter()))
  store.commit("setOutlet", JSON.parse(TokenService.getOutlet()))
}

store.commit("setCompany", JSON.parse(TokenService.getCompany()))
store.commit("setColor", TokenService.getColor())

store.commit("setFcm", TokenService.getFcm())

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  Convert,
  VeeValidate,
  VueQuillEditor,
  VueGoogleMaps,
  VueApexCharts,
  VueAwesomeSwiper,
  VueSocialSharing,
  VueZoomer,
  Firebase,
  VCurrencyField,
  VueHtml2Canvas,
  VueAdvancedCropper,
  GmapVue,
  render: h => h(App)
}).$mount('#app')
